<template>
  <div class="portfolio">
    <Header />
    <HeaderBottomPortfolio />
    <div class="investment-portfolio">
      <b-container class="portfolio-container">
        <div class="portfolio-title mb-4">
          <b-row class="justify-content-md-center">
            <h1>Portfolio</h1>
          </b-row>
        </div>

        <div class="portfolio-list">
          <b-row class="justify-content-md-center">
            <div class="col-lg-4 col-md-6">
              <b-skeleton-wrapper :loading="loading">
                <template #loading>
                  <div class="my-4">
                    <b-skeleton width="60%"></b-skeleton>
                    <b-skeleton width="55%"></b-skeleton>
                  </div>
                  <div>
                    <b-skeleton width="80%"></b-skeleton>
                  </div>
                </template>
                <div class="total-investment">
                  <b-card>
                    <h3>Total Investasi</h3>
                    <p class="mt-n2">Total Investment</p>
                    <h2>
                      <span class="mr-1">IDR</span>
                      {{ formatPrice(sumNominalInvest) }}
                    </h2>
                    <template v-if="modalInvestasiNominal_usd != null">
                      <h2>
                        <span class="mr-1">USD</span>
                        {{ formatUsd(sumNominalInvest_usd) }}
                      </h2>
                    </template>
                  </b-card>
                </div>
              </b-skeleton-wrapper>
            </div>
            <div class="col-lg-4 col-md-6">
              <b-skeleton-wrapper :loading="loading">
                <template #loading>
                  <div class="my-4">
                    <b-skeleton width="60%"></b-skeleton>
                    <b-skeleton width="55%"></b-skeleton>
                  </div>
                  <div>
                    <b-skeleton width="80%"></b-skeleton>
                  </div>
                </template>
                <div class="initial-investment">
                  <b-card>
                    <h3>Modal Investasi</h3>
                    <p class="mt-n2">Initial Investment</p>
                    <h2>
                      <span class="mr-1">IDR</span>
                      {{ formatPrice(modalInvestasiNominal) }}
                    </h2>
                    <template v-if="modalInvestasiNominal_usd != null">
                      <h2>
                        <span class="mr-1">USD</span>
                        {{ formatUsd(modalInvestasiNominal_usd) }}
                      </h2>
                    </template>
                  </b-card>
                </div>
              </b-skeleton-wrapper>
            </div>
            <div class="col-lg-4 col-md-6">
              <b-skeleton-wrapper :loading="loading">
                <template #loading>
                  <div class="my-4">
                    <b-skeleton width="60%"></b-skeleton>
                    <b-skeleton width="55%"></b-skeleton>
                  </div>
                  <div>
                    <b-skeleton width="80%"></b-skeleton>
                  </div>
                </template>
                <div class="profit-loss">
                  <b-card>
                    <h3>Imbal Hasil</h3>
                    <p class="mt-n2">Profit / Loss</p>
                    <h2>
                      <span class="mr-1">IDR</span>
                      {{ formatPrice(total_return_rupiah) }}

                      <span
                        class="percentage mx-2"
                        :class="{
                          'text-success': total_return_percent >= 0,
                          'text-danger': total_return_percent < 0,
                        }"
                      >
                        <template v-if="total_return_percent >= 0">
                          <b-icon icon="caret-up-fill"> </b-icon>
                        </template>
                        <template v-else>
                          <b-icon icon="caret-down-fill"> </b-icon>
                        </template>
                        {{ total_return_percent | formatPercent }}%</span
                      >
                    </h2>
                    <template v-if="modalInvestasiNominal_usd != null">
                      <h2>
                        <span class="mr-1">USD</span>
                        {{ formatUsd(total_return_usd) }}

                        <span
                          class="percentage mx-2"
                          :class="{
                            'text-success': total_return_percent_usd >= 0,
                            'text-danger': total_return_percent_usd < 0,
                          }"
                        >
                          <template v-if="total_return_percent_usd >= 0">
                            <b-icon icon="caret-up-fill"> </b-icon>
                          </template>
                          <template v-else>
                            <b-icon icon="caret-down-fill"> </b-icon>
                          </template>
                          {{ total_return_percent_usd | formatPercent }}%</span
                        >
                      </h2>
                    </template>
                  </b-card>
                </div>
              </b-skeleton-wrapper>
            </div>
          </b-row>
        </div>
      </b-container>
    </div>

    <div class="portfolio-product">
      <b-container class="portfolio-product-container">
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <b-row class="my-4 p-4">
              <div class="col-lg-3 col-md-6">
                <b-row>
                  <div class="col-lg-4 col-md-6 mb-4">
                    <b-skeleton type="avatar"></b-skeleton>
                  </div>
                  <div class="col-lg-8 col-md-6">
                    <b-skeleton width="80%"></b-skeleton>
                    <b-skeleton width="70%"></b-skeleton>
                    <b-skeleton width="40%"></b-skeleton>
                  </div>
                </b-row>
              </div>

              <div class="col-lg-2 col-md-6 mb-4">
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="60%"></b-skeleton>
              </div>
              <div class="col-lg-2 col-md-6">
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="60%"></b-skeleton>
              </div>
              <div class="col-lg-3 col-md-6">
                <b-skeleton></b-skeleton>
              </div>
            </b-row>
            <b-row class="my-4 p-4">
              <div class="col-lg-3 col-md-6">
                <b-row>
                  <div class="col-lg-4 col-md-6 mb-4">
                    <b-skeleton type="avatar"></b-skeleton>
                  </div>
                  <div class="col-lg-8 col-md-6">
                    <b-skeleton width="80%"></b-skeleton>
                    <b-skeleton width="70%"></b-skeleton>
                    <b-skeleton width="40%"></b-skeleton>
                  </div>
                </b-row>
              </div>

              <div class="col-lg-2 col-md-6 mb-4">
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="60%"></b-skeleton>
              </div>
              <div class="col-lg-2 col-md-6">
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="60%"></b-skeleton>
              </div>
              <div class="col-lg-3 col-md-6">
                <b-skeleton></b-skeleton>
              </div>
            </b-row>
            <b-row class="my-4 p-4">
              <div class="col-lg-3 col-md-6">
                <b-row>
                  <div class="col-lg-4 col-md-6 mb-4">
                    <b-skeleton type="avatar"></b-skeleton>
                  </div>
                  <div class="col-lg-8 col-md-6">
                    <b-skeleton width="80%"></b-skeleton>
                    <b-skeleton width="70%"></b-skeleton>
                    <b-skeleton width="40%"></b-skeleton>
                  </div>
                </b-row>
              </div>

              <div class="col-lg-2 col-md-6 mb-4">
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="60%"></b-skeleton>
              </div>
              <div class="col-lg-2 col-md-6">
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="60%"></b-skeleton>
              </div>
              <div class="col-lg-3 col-md-6">
                <b-skeleton></b-skeleton>
              </div>
            </b-row>
          </template>

          <div v-if="user.institutional != null">
            <div class="py-2"></div>
          </div>
          <div v-else>
            <div class="row pt-4">
              <div class="col-lg-12 col-md-6 d-flex flex-row-reverse">
                <div class="mx-2 show-transaction-proccess">
                  <p>Tampilkan Transaksi Dalam Proses</p>
                </div>
                <div class="align-items-center">
                  <vs-checkbox
                    v-model="ShowActivitiesChecked"
                    color="secondary"
                  >
                  </vs-checkbox>
                </div>
              </div>
            </div>
          </div>

          <div v-if="user.institutional != null">
            <div class="d-none d-lg-block d-md-block">
              <div v-for="(value, index) in portfolios" :key="index">
                <template v-if="value.amount > 0">
                  <b-card class="portfolio-product-card mt-2">
                    <b-row class="justify-content-center mx-auto">
                      <div class="col-lg-6 col-md-6 mb-2 my-auto">
                        <div class="fund-name mt-3">
                          <b-link
                            :to="
                              'subscription-product-detail/' +
                              value.fund_code +
                              '/' +
                              value.product_id +
                              '/' +
                              value.fund_name
                            "
                            class="text-decoration-none"
                          >
                            <b-row>
                              <b-col cols="2">
                                <div v-if="value.image == null">
                                  <img
                                    :src="
                                      'https://ui-avatars.com/api/?background=3F0975&color=fff&name=' +
                                      value.fund_name
                                    "
                                  />
                                </div>
                                <div v-else>
                                  <img
                                    :src="`https://core.invesnow.id/images/products/${value.image}`"
                                    alt="Fund Image"
                                  />
                                </div>
                              </b-col>
                              <b-col class="ml-2 my-auto">
                                <h4>
                                  {{ value.fund_name }}
                                </h4>
                                <p class="mt-n2">
                                  {{ value.fund_type }}
                                </p>
                              </b-col>
                            </b-row>
                          </b-link>
                        </div>
                      </div>
                      <div class="col-lg-3 col-md-6 mb-2 my-auto">
                        <div class="investment-value">
                          <p>
                            {{ value.outstanding_unit_balance | formatDecimal }}
                            unit
                          </p>
                          <h3 class="mt-n3">
                            {{ value.fund_ccy }}
                            {{
                              value.fund_ccy == "IDR"
                                ? formatPrice(value.amount)
                                : formatUsd(value.amount)
                            }}
                          </h3>
                        </div>
                      </div>

                      <div class="col-lg-3 col-md-6 my-auto">
                        <div class="profit">
                          <p>
                            <span
                              :class="{
                                'text-success': value.return_persen >= 0,
                                'text-danger': value.return_persen < 0,
                              }"
                            >
                              <template v-if="value.return_persen >= 0">
                                <b-icon icon="caret-up-fill"></b-icon>
                              </template>

                              <template v-else>
                                <b-icon icon="caret-down-fill"></b-icon>
                              </template>

                              {{ value.return_persen | formatPercent }}
                              %
                            </span>
                          </p>
                          <h3 class="mt-n3">
                            <span
                              :class="{
                                'text-success': value.return_persen >= 0,
                                'text-danger': value.return_persen < 0,
                              }"
                            >
                              {{ value.fund_ccy }}
                              {{
                                value.fund_ccy == "IDR"
                                  ? formatPrice(value.return_rupiah)
                                  : formatUsd(value.return_usd)
                              }}
                            </span>
                          </h3>
                        </div>
                      </div>
                    </b-row>
                    <template v-if="orders">
                      <div v-show="ShowActivitiesChecked">
                        <div
                          class="
                            row
                            portfolio-on-process-card
                            justify-content-center
                            border-none
                            pt-4
                          "
                        >
                          <div
                            class="
                              col-lg-4 col-md-6
                              border-right border-top
                              px-4
                              pt-4
                              pb-0
                            "
                          >
                            <h3 v-show="ShowActivitiesChecked">
                              Pembelian Dalam Proses
                            </h3>
                            <div
                              v-for="(subscription, index) in subscriptionTrx"
                              :key="index"
                            >
                              <div
                                v-if="
                                  (subscription.fund_code == value.fund_code &&
                                    subscription.status == 'waiting sales') ||
                                  (subscription.fund_code == value.fund_code &&
                                    subscription.status == 'waiting confirm') ||
                                  (subscription.fund_code == value.fund_code &&
                                    subscription.status ==
                                      'waiting transfer') ||
                                  (subscription.fund_code == value.fund_code &&
                                    subscription.status == 'approve')
                                "
                              >
                                <p>
                                  {{
                                    subscription.product
                                      ? subscription.product.fund_ccy
                                      : ""
                                  }}{{
                                    formatPrice(subscription.amount_nominal)
                                  }}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-lg-4 col-md-6 border-top px-4 pt-4 pb-0"
                          >
                            <h3 v-show="ShowActivitiesChecked">
                              Penjualan Dalam Proses
                            </h3>
                            <div
                              v-for="(redeem, index) in redeemTrx"
                              :key="index"
                            >
                              <div
                                v-if="
                                  (redeem.fund_code == value.fund_code &&
                                    redeem.status == 'waiting sales') ||
                                  (redeem.fund_code == value.fund_code &&
                                    redeem.status == 'waiting confirm') ||
                                  (redeem.fund_code == value.fund_code &&
                                    redeem.status == 'approve')
                                "
                              >
                                <p>
                                  {{
                                    redeem.product
                                      ? redeem.product.fund_ccy
                                      : ""
                                  }}{{ formatPrice(redeem.amount_nominal) }} /
                                  <span
                                    >{{
                                      redeem.amount_unit | formatDecimal
                                    }}
                                    unit</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            class="
                              col-lg-4 col-md-6
                              border-top border-left
                              px-4
                              pt-4
                              pb-0
                            "
                          >
                            <h3 v-show="ShowActivitiesChecked">
                              Pengalihan Dalam Proses
                            </h3>
                            <div
                              v-for="(switching, index) in switchingTrx"
                              :key="index"
                            >
                              <div
                                v-if="
                                  (switching.product_out.fund_code ==
                                    value.fund_code &&
                                    switching.status == 'waiting sales') ||
                                  (switching.product_out.fund_code ==
                                    value.fund_code &&
                                    switching.status == 'waiting confirm') ||
                                  (switching.product_out.fund_code ==
                                    value.fund_code &&
                                    switching.status == 'approve')
                                "
                              >
                                <p>
                                  {{
                                    switching.product
                                      ? switching.product.fund_ccy
                                      : ""
                                  }}{{
                                    formatPrice(switching.switch_out_nominal)
                                  }}
                                  /
                                  <span
                                    >{{
                                      switching.switch_out_unit | formatDecimal
                                    }}
                                    unit</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>

                    <div class="modal-portfolio-detail">
                      <b-modal
                        id="modal-portfolio-detail"
                        size="md"
                        class="modal-portfolio-detail"
                        centered
                        hide-footer
                      >
                        <div class="d-block text-center">
                          <div class="fund-name-modal">
                            <b-row class="justify-content-center">
                              <b-col cols="2" class="image-modal ml-5">
                                <div v-if="value.image == null">
                                  <img
                                    :src="
                                      'https://ui-avatars.com/api/?background=3F0975&color=fff&name=' +
                                      value.fund_name
                                    "
                                  />
                                </div>
                                <div v-else>
                                  <img
                                    :src="`https://core.invesnow.id/images/products/${value.image}`"
                                    alt="Fund Image"
                                  />
                                </div>
                              </b-col>
                              <b-col class="fund-name-modal">
                                <h4>
                                  {{ value.fund_name }}
                                </h4>
                                <p class="mt-n2">
                                  {{ value.fund_type }}
                                </p>
                              </b-col>
                            </b-row>
                          </div>
                          <div class="value-now-modal">
                            <b-row class="mt-4">
                              <b-col class="my-auto">
                                <p class="variant">Nilai Investasi</p>
                              </b-col>
                              <b-col class="my-auto">
                                <p class="value">
                                  IDR{{ formatPrice(value.amount) }}
                                </p>
                              </b-col>
                            </b-row>
                          </div>
                          <hr />
                          <div class="initial-investment-modal">
                            <b-row class="mt-2">
                              <b-col class="my-auto">
                                <p class="variant">Modal Investasi</p>
                              </b-col>
                              <b-col class="my-auto">
                                <p class="value">
                                  IDR{{ formatPrice(value.modalInvestasi) }}
                                </p>
                              </b-col>
                            </b-row>
                          </div>
                          <hr />
                          <div class="profit-modal">
                            <b-row class="mt-2">
                              <b-col class="my-auto">
                                <p class="variant">Imbal Hasil</p>
                              </b-col>
                              <b-col class="my-auto">
                                <p class="value">
                                  <span class="text-success mx-2"
                                    ><b-icon
                                      class="ml-2 mr-1"
                                      icon="caret-up-fill"
                                    ></b-icon>
                                    {{ value.return_persen | formatPercent }}
                                    %</span
                                  ><span>IDR</span>
                                  {{ formatPrice(value.return_rupiah) }}
                                </p>
                              </b-col>
                            </b-row>
                          </div>
                          <hr />
                          <div class="buy-cost-modal">
                            <b-row class="mt-2">
                              <b-col>
                                <p class="variant">Harga Beli</p>
                              </b-col>
                              <b-col class="my-auto">
                                <p class="value">
                                  IDR{{ value.nav_per_unit | formatDecimal }}
                                </p>
                              </b-col>
                            </b-row>
                          </div>
                          <div class="unit-modal">
                            <b-row class="mt-2">
                              <b-col>
                                <p class="variant">Unit</p>
                              </b-col>
                              <b-col class="my-auto">
                                <p class="value">
                                  {{
                                    value.outstanding_unit_balance
                                      | formatDecimal
                                  }}
                                  unit
                                </p>
                              </b-col>
                            </b-row>
                          </div>
                        </div>
                      </b-modal>
                    </div>
                  </b-card>
                  <!-- <div v-show="ShowActivitiesChecked">
                  <div v-for="(value, index) in orders" :key="index">
                    <template>
                      <b-card class="portfolio-on-process-card mt-0">
                        <div class="row justify-content-center">
                          <div class="col-lg-4 col-md-6 border-right">
                              <h3>Pembelian Dalam Proses</h3>
                            <div v-if="value.id_transaction_type == 1">
                              <p>{{value.product ? value.product.fund_ccy : ""}}{{formatPrice(value.amount_nominal)}}</p>
                            </div>
                            <div else>
                              <p>-</p>
                            </div>
                          </div>
                          <div class="col-lg-4 col-md-6">
                            <h3>Penjualan Dalam Proses</h3>
                            <div v-if="value.id_transaction_type == 2">
                              <p>{{value.product ? value.product.fund_ccy : ""}}{{formatPrice(value.amount_nominal)}} / <span>{{ value.amount_unit | formatDecimal}} unit</span></p>
                            </div>
                            <div else>
                              <p>-</p>
                            </div>
                          </div>
                          <div class="col-lg-4 col-md-6 border-left">
                            <h3>Pengalihan Dalam Proses</h3>
                            <div v-if="value.id_transaction_type == 3">
                            <p>{{value.product ? value.product.fund_ccy : ""}}{{formatPrice(value.amount_nominal)}} / <span>{{value.amount_unit | formatDecimal}} unit</span></p>
                            </div>
                            <div else>
                              <p>-</p>
                            </div>
                          </div>
                        </div>
                      </b-card>
                    </template>
                  </div>
              </div> -->
                </template>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="d-none d-lg-block d-md-block">
              <div v-for="(value, index) in portfolios" :key="index">
                <template v-if="value.amount > 0">
                  <b-card class="portfolio-product-card mt-2">
                    <b-row class="justify-content-center mx-auto">
                      <div class="col-lg-3 col-md-6 mb-2 my-auto">
                        <div class="fund-name mt-3">
                          <b-link
                            :to="
                              'subscription-product-detail/' +
                              value.fund_code +
                              '/' +
                              value.product_id +
                              '/' +
                              value.fund_name
                            "
                            class="text-decoration-none"
                          >
                            <b-row>
                              <b-col cols="2">
                                <div v-if="value.image == null">
                                  <img
                                    :src="
                                      'https://ui-avatars.com/api/?background=3F0975&color=fff&name=' +
                                      value.fund_name
                                    "
                                  />
                                </div>
                                <div v-else>
                                  <img
                                    :src="`https://core.invesnow.id/images/products/${value.image}`"
                                    alt="Fund Image"
                                  />
                                </div>
                              </b-col>
                              <b-col class="ml-2 my-auto">
                                <h4>
                                  {{ value.fund_name }}
                                </h4>
                                <p class="mt-n2">
                                  {{ value.fund_type }}
                                </p>
                              </b-col>
                            </b-row>
                          </b-link>
                        </div>
                      </div>
                      <div class="col-lg-2 col-md-6 mb-2 my-auto">
                        <div class="investment-value">
                          <p>
                            {{ value.outstanding_unit_balance | formatDecimal }}
                            unit
                          </p>
                          <h3 class="mt-n3">
                            {{ value.fund_ccy }}
                            {{
                              value.fund_ccy == "IDR"
                                ? formatPrice(value.amount)
                                : formatUsd(value.amount)
                            }}
                          </h3>
                        </div>
                      </div>

                      <div class="col-lg-2 col-md-6 my-auto">
                        <div class="profit">
                          <p>
                            <span
                              :class="{
                                'text-success': value.return_persen >= 0,
                                'text-danger': value.return_persen < 0,
                              }"
                            >
                              <template v-if="value.return_persen >= 0">
                                <b-icon icon="caret-up-fill"></b-icon>
                              </template>

                              <template v-else>
                                <b-icon icon="caret-down-fill"></b-icon>
                              </template>

                              {{ value.return_persen | formatPercent }}
                              %
                            </span>
                          </p>
                          <h3 class="mt-n3">
                            <span
                              :class="{
                                'text-success': value.return_persen >= 0,
                                'text-danger': value.return_persen < 0,
                              }"
                            >
                              {{ value.fund_ccy }}
                              {{
                                value.fund_ccy == "IDR"
                                  ? formatPrice(value.return_rupiah)
                                  : formatUsd(value.return_usd)
                              }}
                            </span>
                          </h3>
                        </div>
                      </div>
                      <div class="col-lg-2 col-md-6 my-auto">
                        <div class="top-up-link">
                          <b-button
                            :to="
                              'subscription-product-detail/' +
                              value.fund_code +
                              '/' +
                              value.product_id +
                              '/' +
                              value.fund_name
                            "
                            class="btn-tertiary px-4 py-2"
                          >
                            Beli Lagi
                          </b-button>
                        </div>
                      </div>

                      <div class="col-lg-1 col-md-6 my-auto">
                        <div class="switching-link mt-2">
                          <h3>
                            <!-- <b-button @click="next_switch(value.porto_sementara, value.min_sell, value.fund_code, value.im_id)" 
                        >Alihkan</b-button
                      > -->
                            <b-link
                              :href="
                                '/switching-list-product/' +
                                value.fund_code +
                                '/' +
                                value.im_id
                              "
                              >Alihkan</b-link
                            >
                          </h3>
                        </div>
                      </div>

                      <div class="col-lg-2 col-md-6 my-auto">
                        <div class="redeem-link mt-2">
                          <h3>
                            <!-- <b-button class="btn-danger" @click="next_jual(value.porto_sementara, value.min_sell, value.fund_code)"
                        >Jual Kembali</b-button
                      > -->
                            <b-link :href="'/redeem/' + value.fund_code"
                              >Jual Kembali</b-link
                            >
                          </h3>
                        </div>
                      </div>
                    </b-row>
                    <template v-if="orders">
                      <div v-show="ShowActivitiesChecked">
                        <div
                          class="
                            row
                            portfolio-on-process-card
                            justify-content-center
                            border-none
                            pt-4
                          "
                        >
                          <div
                            class="
                              col-lg-4 col-md-6
                              border-right border-top
                              px-4
                              pt-4
                              pb-0
                            "
                          >
                            <h3 v-show="ShowActivitiesChecked">
                              Pembelian Dalam Proses
                            </h3>
                            <div
                              v-for="(subscription, index) in subscriptionTrx"
                              :key="index"
                            >
                              <div
                                v-if="
                                  (subscription.fund_code == value.fund_code &&
                                    subscription.status == 'waiting sales') ||
                                  (subscription.fund_code == value.fund_code &&
                                    subscription.status == 'waiting confirm') ||
                                  (subscription.fund_code == value.fund_code &&
                                    subscription.status ==
                                      'waiting transfer') ||
                                  (subscription.fund_code == value.fund_code &&
                                    subscription.status == 'approve')
                                "
                              >
                                <p>
                                  {{
                                    subscription.product
                                      ? subscription.product.fund_ccy
                                      : ""
                                  }}{{
                                    formatPrice(subscription.amount_nominal)
                                  }}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-lg-4 col-md-6 border-top px-4 pt-4 pb-0"
                          >
                            <h3 v-show="ShowActivitiesChecked">
                              Penjualan Dalam Proses
                            </h3>
                            <div
                              v-for="(redeem, index) in redeemTrx"
                              :key="index"
                            >
                              <div
                                v-if="
                                  (redeem.fund_code == value.fund_code &&
                                    redeem.status == 'waiting sales') ||
                                  (redeem.fund_code == value.fund_code &&
                                    redeem.status == 'waiting confirm') ||
                                  (redeem.fund_code == value.fund_code &&
                                    redeem.status == 'approve')
                                "
                              >
                                <p>
                                  {{
                                    redeem.product
                                      ? redeem.product.fund_ccy
                                      : ""
                                  }}{{ formatPrice(redeem.amount_nominal) }} /
                                  <span
                                    >{{
                                      redeem.amount_unit | formatDecimal
                                    }}
                                    unit</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            class="
                              col-lg-4 col-md-6
                              border-top border-left
                              px-4
                              pt-4
                              pb-0
                            "
                          >
                            <h3 v-show="ShowActivitiesChecked">
                              Pengalihan Dalam Proses
                            </h3>
                            <div
                              v-for="(switching, index) in switchingTrx"
                              :key="index"
                            >
                              <div
                                v-if="
                                  (switching.product_out.fund_code ==
                                    value.fund_code &&
                                    switching.status == 'waiting sales') ||
                                  (switching.product_out.fund_code ==
                                    value.fund_code &&
                                    switching.status == 'waiting confirm') ||
                                  (switching.product_out.fund_code ==
                                    value.fund_code &&
                                    switching.status == 'approve')
                                "
                              >
                                <p>
                                  {{
                                    switching.product
                                      ? switching.product.fund_ccy
                                      : ""
                                  }}{{
                                    formatPrice(switching.switch_out_nominal)
                                  }}
                                  /
                                  <span
                                    >{{
                                      switching.switch_out_unit | formatDecimal
                                    }}
                                    unit</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>

                    <div class="modal-portfolio-detail">
                      <b-modal
                        id="modal-portfolio-detail"
                        size="md"
                        class="modal-portfolio-detail"
                        centered
                        hide-footer
                      >
                        <div class="d-block text-center">
                          <div class="fund-name-modal">
                            <b-row class="justify-content-center">
                              <b-col cols="2" class="image-modal ml-5">
                                <img
                                  :src="
                                    'https://ui-avatars.com/api/?background=3F0975&color=fff&name=' +
                                    value.fund_name
                                  "
                                />
                              </b-col>
                              <b-col class="fund-name-modal">
                                <h4>
                                  {{ value.fund_name }}
                                </h4>
                                <p class="mt-n2">
                                  {{ value.fund_type }}
                                </p>
                              </b-col>
                            </b-row>
                          </div>
                          <div class="value-now-modal">
                            <b-row class="mt-4">
                              <b-col class="my-auto">
                                <p class="variant">Nilai Investasi</p>
                              </b-col>
                              <b-col class="my-auto">
                                <p class="value">
                                  IDR{{ formatPrice(value.amount) }}
                                </p>
                              </b-col>
                            </b-row>
                          </div>
                          <hr />
                          <div class="initial-investment-modal">
                            <b-row class="mt-2">
                              <b-col class="my-auto">
                                <p class="variant">Modal Investasi</p>
                              </b-col>
                              <b-col class="my-auto">
                                <p class="value">
                                  IDR{{ formatPrice(value.modalInvestasi) }}
                                </p>
                              </b-col>
                            </b-row>
                          </div>
                          <hr />
                          <div class="profit-modal">
                            <b-row class="mt-2">
                              <b-col class="my-auto">
                                <p class="variant">Imbal Hasil</p>
                              </b-col>
                              <b-col class="my-auto">
                                <p class="value">
                                  <span class="text-success mx-2"
                                    ><b-icon
                                      class="ml-2 mr-1"
                                      icon="caret-up-fill"
                                    ></b-icon>
                                    {{ value.return_persen | formatPercent }}
                                    %</span
                                  ><span>IDR</span>
                                  {{ formatPrice(value.return_rupiah) }}
                                </p>
                              </b-col>
                            </b-row>
                          </div>
                          <hr />
                          <div class="buy-cost-modal">
                            <b-row class="mt-2">
                              <b-col>
                                <p class="variant">Harga Beli</p>
                              </b-col>
                              <b-col class="my-auto">
                                <p class="value">
                                  IDR{{ value.nav_per_unit | formatDecimal }}
                                </p>
                              </b-col>
                            </b-row>
                          </div>
                          <div class="unit-modal">
                            <b-row class="mt-2">
                              <b-col>
                                <p class="variant">Unit</p>
                              </b-col>
                              <b-col class="my-auto">
                                <p class="value">
                                  {{
                                    value.outstanding_unit_balance
                                      | formatDecimal
                                  }}
                                  unit
                                </p>
                              </b-col>
                            </b-row>
                          </div>
                        </div>
                      </b-modal>
                    </div>
                  </b-card>
                  <!-- <div v-show="ShowActivitiesChecked">
                  <div v-for="(value, index) in orders" :key="index">
                    <template>
                      <b-card class="portfolio-on-process-card mt-0">
                        <div class="row justify-content-center">
                          <div class="col-lg-4 col-md-6 border-right">
                              <h3>Pembelian Dalam Proses</h3>
                            <div v-if="value.id_transaction_type == 1">
                              <p>{{value.product ? value.product.fund_ccy : ""}}{{formatPrice(value.amount_nominal)}}</p>
                            </div>
                            <div else>
                              <p>-</p>
                            </div>
                          </div>
                          <div class="col-lg-4 col-md-6">
                            <h3>Penjualan Dalam Proses</h3>
                            <div v-if="value.id_transaction_type == 2">
                              <p>{{value.product ? value.product.fund_ccy : ""}}{{formatPrice(value.amount_nominal)}} / <span>{{ value.amount_unit | formatDecimal}} unit</span></p>
                            </div>
                            <div else>
                              <p>-</p>
                            </div>
                          </div>
                          <div class="col-lg-4 col-md-6 border-left">
                            <h3>Pengalihan Dalam Proses</h3>
                            <div v-if="value.id_transaction_type == 3">
                            <p>{{value.product ? value.product.fund_ccy : ""}}{{formatPrice(value.amount_nominal)}} / <span>{{value.amount_unit | formatDecimal}} unit</span></p>
                            </div>
                            <div else>
                              <p>-</p>
                            </div>
                          </div>
                        </div>
                      </b-card>
                    </template>
                  </div>
              </div> -->
                </template>
              </div>
            </div>
          </div>

          <div v-if="user.institutional != null">
            <div class="d-block d-lg-none d-md-none">
              <div v-for="(value, index) in portfolios" :key="index">
                <template v-if="value.amount > 0">
                  <b-card class="portfolio-product-card mt-2">
                    <b-row class="justify-content-center mx-auto">
                      <div class="col-lg-3 col-md-6 mb-2 my-auto">
                        <div class="fund-name mt-3">
                          <b-row>
                            <b-col cols="2">
                              <img
                                :src="
                                  'https://ui-avatars.com/api/?background=3F0975&color=fff&name=' +
                                  value.fund_name
                                "
                              />
                            </b-col>
                            <b-col class="ml-2 my-auto">
                              <h4>
                                {{ value.fund_name }}
                              </h4>
                              <p class="mt-n2">
                                {{ value.fund_type }}
                              </p>
                            </b-col>
                          </b-row>
                        </div>
                      </div>
                      <div class="col-6 mb-2 my-auto">
                        <div class="investment-value">
                          <p>
                            {{ value.outstanding_unit_balance | formatDecimal }}
                            unit
                          </p>
                        </div>
                      </div>
                      <div class="col-6 mb-2 my-auto">
                        <div class="investment-value">
                          <h3 class="mt-n1">
                            {{ value.fund_ccy }}
                            {{
                              value.fund_ccy == "IDR"
                                ? formatPrice(value.amount)
                                : formatUsd(value.amount)
                            }}
                          </h3>
                        </div>
                      </div>

                      <div class="col-6 my-auto">
                        <div class="profit">
                          <p>
                            <span
                              :class="{
                                'text-success': value.return_persen >= 0,
                                'text-danger': value.return_persen < 0,
                              }"
                            >
                              <template v-if="value.return_persen >= 0">
                                <b-icon icon="caret-up-fill"></b-icon>
                              </template>

                              <template v-else>
                                <b-icon icon="caret-down-fill"></b-icon>
                              </template>

                              {{ value.return_persen | formatPercent }}
                              %
                            </span>
                          </p>
                        </div>
                      </div>
                      <div class="col-6 my-auto">
                        <div class="profit">
                          <h3 class="mt-n1">
                            <span
                              :class="{
                                'text-success': value.return_persen >= 0,
                                'text-danger': value.return_persen < 0,
                              }"
                            >
                              {{ value.fund_ccy }}
                              {{
                                value.fund_ccy == "IDR"
                                  ? formatPrice(value.return_rupiah)
                                  : formatUsd(value.return_usd)
                              }}
                            </span>
                          </h3>
                        </div>
                      </div>
                    </b-row>
                    <template v-if="orders">
                      <div v-show="ShowActivitiesChecked">
                        <div
                          class="
                            row
                            portfolio-on-process-card
                            justify-content-center
                            border-none
                            pt-4
                          "
                        >
                          <div
                            class="col-lg-4 col-md-6 border-top px-4 pt-4 pb-0"
                          >
                            <h3 v-show="ShowActivitiesChecked">
                              Pembelian Dalam Proses
                            </h3>
                            <div
                              v-for="(subscription, index) in subscriptionTrx"
                              :key="index"
                            >
                              <div
                                v-if="
                                  (subscription.fund_code == value.fund_code &&
                                    subscription.status == 'waiting sales') ||
                                  (subscription.fund_code == value.fund_code &&
                                    subscription.status == 'waiting confirm') ||
                                  (subscription.fund_code == value.fund_code &&
                                    subscription.status ==
                                      'waiting transfer') ||
                                  (subscription.fund_code == value.fund_code &&
                                    subscription.status == 'approve')
                                "
                              >
                                <p>
                                  {{
                                    subscription.product
                                      ? subscription.product.fund_ccy
                                      : ""
                                  }}{{
                                    formatPrice(subscription.amount_nominal)
                                  }}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-lg-4 col-md-6 border-top px-4 pt-4 pb-0"
                          >
                            <h3 v-show="ShowActivitiesChecked">
                              Penjualan Dalam Proses
                            </h3>
                            <div
                              v-for="(redeem, index) in redeemTrx"
                              :key="index"
                            >
                              <div
                                v-if="
                                  (redeem.fund_code == value.fund_code &&
                                    redeem.status == 'waiting sales') ||
                                  (redeem.fund_code == value.fund_code &&
                                    redeem.status == 'waiting confirm') ||
                                  (redeem.fund_code == value.fund_code &&
                                    redeem.status == 'approve')
                                "
                              >
                                <p>
                                  {{
                                    redeem.product
                                      ? redeem.product.fund_ccy
                                      : ""
                                  }}{{ formatPrice(redeem.amount_nominal) }} /
                                  <span
                                    >{{
                                      redeem.amount_unit | formatDecimal
                                    }}
                                    unit</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-lg-4 col-md-6 border-top px-4 pt-4 pb-0"
                          >
                            <h3 v-show="ShowActivitiesChecked">
                              Pengalihan Dalam Proses
                            </h3>
                            <div
                              v-for="(switching, index) in switchingTrx"
                              :key="index"
                            >
                              <div
                                v-if="
                                  (switching.product_out.fund_code ==
                                    value.fund_code &&
                                    switching.status == 'waiting sales') ||
                                  (switching.product_out.fund_code ==
                                    value.fund_code &&
                                    switching.status == 'waiting confirm') ||
                                  (switching.product_out.fund_code ==
                                    value.fund_code &&
                                    switching.status == 'approve')
                                "
                              >
                                <p>
                                  {{
                                    switching.product
                                      ? switching.product.fund_ccy
                                      : ""
                                  }}{{
                                    formatPrice(switching.switch_out_nominal)
                                  }}
                                  /
                                  <span
                                    >{{
                                      switching.switch_out_unit | formatDecimal
                                    }}
                                    unit</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </b-card>
                </template>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="d-block d-lg-none d-md-none">
              <div v-for="(value, index) in portfolios" :key="index">
                <template v-if="value.amount > 0">
                  <b-card class="portfolio-product-card mt-2">
                    <b-row class="justify-content-center mx-auto">
                      <div class="col-lg-3 col-md-6 mb-2 my-auto">
                        <div class="fund-name mt-3">
                          <b-row>
                            <b-col cols="2">
                              <div v-if="value.image == null">
                                <img
                                  :src="
                                    'https://ui-avatars.com/api/?background=3F0975&color=fff&name=' +
                                    value.fund_name
                                  "
                                />
                              </div>
                              <div v-else>
                                <img
                                  :src="`https://core.invesnow.id/images/products/${value.image}`"
                                  alt="Fund Image"
                                />
                              </div>
                            </b-col>
                            <b-col class="ml-2 my-auto">
                              <h4>
                                {{ value.fund_name }}
                              </h4>
                              <p class="mt-n2">
                                {{ value.fund_type }}
                              </p>
                            </b-col>
                          </b-row>
                        </div>
                      </div>
                      <div class="col-6 mb-2 my-auto">
                        <div class="investment-value">
                          <p>
                            {{ value.outstanding_unit_balance | formatDecimal }}
                            unit
                          </p>
                        </div>
                      </div>
                      <div class="col-6 mb-2 my-auto">
                        <div class="investment-value">
                          <h3 class="mt-n1">
                            {{ value.fund_ccy }}
                            {{
                              value.fund_ccy == "IDR"
                                ? formatPrice(value.amount)
                                : formatUsd(value.amount)
                            }}
                          </h3>
                        </div>
                      </div>

                      <div class="col-6 my-auto">
                        <div class="profit">
                          <p>
                            <span
                              :class="{
                                'text-success': value.return_persen >= 0,
                                'text-danger': value.return_persen < 0,
                              }"
                            >
                              <template v-if="value.return_persen >= 0">
                                <b-icon icon="caret-up-fill"></b-icon>
                              </template>

                              <template v-else>
                                <b-icon icon="caret-down-fill"></b-icon>
                              </template>

                              {{ value.return_persen | formatPercent }}
                              %
                            </span>
                          </p>
                        </div>
                      </div>
                      <div class="col-6 my-auto">
                        <div class="profit">
                          <h3 class="mt-n1">
                            <span
                              :class="{
                                'text-success': value.return_persen >= 0,
                                'text-danger': value.return_persen < 0,
                              }"
                            >
                              {{ value.fund_ccy }}
                              {{
                                value.fund_ccy == "IDR"
                                  ? formatPrice(value.return_rupiah)
                                  : formatUsd(value.return_usd)
                              }}
                            </span>
                          </h3>
                        </div>
                      </div>
                      <div class="col-lg-2 col-md-6 my-auto py-2">
                        <div class="top-up-link">
                          <b-button
                            block
                            :to="
                              'subscription-product-detail/' +
                              value.fund_code +
                              '/' +
                              value.product_id +
                              '/' +
                              value.fund_name
                            "
                            class="btn-tertiary px-4 py-2"
                          >
                            Beli Lagi
                          </b-button>
                        </div>
                      </div>

                      <div class="col-6 my-auto">
                        <div class="redeem-link mt-2">
                          <h3>
                            <b-link :href="'/redeem/' + value.fund_code"
                              >Jual Kembali</b-link
                            >
                          </h3>
                        </div>
                      </div>

                      <div class="col-6 my-auto">
                        <div class="switching-link mt-2">
                          <h3>
                            <b-link
                              :href="
                                '/switching-list-product/' +
                                value.fund_code +
                                '/' +
                                value.im_id
                              "
                              >Alihkan</b-link
                            >
                          </h3>
                        </div>
                      </div>
                    </b-row>
                    <template v-if="orders">
                      <div v-show="ShowActivitiesChecked">
                        <div
                          class="
                            row
                            portfolio-on-process-card
                            justify-content-center
                            border-none
                            pt-4
                          "
                        >
                          <div
                            class="col-lg-4 col-md-6 border-top px-4 pt-4 pb-0"
                          >
                            <h3 v-show="ShowActivitiesChecked">
                              Pembelian Dalam Proses
                            </h3>
                            <div
                              v-for="(subscription, index) in subscriptionTrx"
                              :key="index"
                            >
                              <div
                                v-if="
                                  (subscription.fund_code == value.fund_code &&
                                    subscription.status == 'waiting sales') ||
                                  (subscription.fund_code == value.fund_code &&
                                    subscription.status == 'waiting confirm') ||
                                  (subscription.fund_code == value.fund_code &&
                                    subscription.status ==
                                      'waiting transfer') ||
                                  (subscription.fund_code == value.fund_code &&
                                    subscription.status == 'approve')
                                "
                              >
                                <p>
                                  {{
                                    subscription.product
                                      ? subscription.product.fund_ccy
                                      : ""
                                  }}{{
                                    formatPrice(subscription.amount_nominal)
                                  }}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-lg-4 col-md-6 border-top px-4 pt-4 pb-0"
                          >
                            <h3 v-show="ShowActivitiesChecked">
                              Penjualan Dalam Proses
                            </h3>
                            <div
                              v-for="(redeem, index) in redeemTrx"
                              :key="index"
                            >
                              <div
                                v-if="
                                  (redeem.fund_code == value.fund_code &&
                                    redeem.status == 'waiting sales') ||
                                  (redeem.fund_code == value.fund_code &&
                                    redeem.status == 'waiting confirm') ||
                                  (redeem.fund_code == value.fund_code &&
                                    redeem.status == 'approve')
                                "
                              >
                                <p>
                                  {{
                                    redeem.product
                                      ? redeem.product.fund_ccy
                                      : ""
                                  }}{{ formatPrice(redeem.amount_nominal) }} /
                                  <span
                                    >{{
                                      redeem.amount_unit | formatDecimal
                                    }}
                                    unit</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-lg-4 col-md-6 border-top px-4 pt-4 pb-0"
                          >
                            <h3 v-show="ShowActivitiesChecked">
                              Pengalihan Dalam Proses
                            </h3>
                            <div
                              v-for="(switching, index) in switchingTrx"
                              :key="index"
                            >
                              <div
                                v-if="
                                  (switching.product_out.fund_code ==
                                    value.fund_code &&
                                    switching.status == 'waiting sales') ||
                                  (switching.product_out.fund_code ==
                                    value.fund_code &&
                                    switching.status == 'waiting confirm') ||
                                  (switching.product_out.fund_code ==
                                    value.fund_code &&
                                    switching.status == 'approve')
                                "
                              >
                                <p>
                                  {{
                                    switching.product
                                      ? switching.product.fund_ccy
                                      : ""
                                  }}{{
                                    formatPrice(switching.switch_out_nominal)
                                  }}
                                  /
                                  <span
                                    >{{
                                      switching.switch_out_unit | formatDecimal
                                    }}
                                    unit</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </b-card>
                </template>
              </div>
            </div>
          </div>

          <div class="disclaimer py-2">
            <b-row class="justify-content-center mb-4">
              <div class="col-lg-12 col-md-6">
                <div class="card p-1">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-lg-12 col-md-6 d-flex">
                        <div class="align-items-center">
                          <img
                            src="@/assets/img/icons/information/information-ic.svg"
                            alt="Disclaimer"
                            class="mr-2"
                          />
                        </div>
                        <p>
                          Transaksi yang sedang dalam proses bisa dilihat di
                          laman
                          <b class="disclaimer-link"
                            ><b-link to="/orders">Transaksi.</b-link></b
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-row>
          </div>

          <div class="invest-button mt-4" v-if="user.individual != null">
            <b-row
              class="justify-content-center"
              v-if="user.individual.ifua == null"
            >
              <b-button to="/pembukaan-akun" class="btn-secondary px-5 py-3">
                + Tambah Investasi
              </b-button>
            </b-row>

            <b-row class="justify-content-center" v-else>
              <b-button to="/reksadana" class="btn-secondary px-5 py-3">
                + Tambah Investasi
              </b-button>
            </b-row>
          </div>

          <div class="invest-button mt-4" v-else>
            <b-row
              class="justify-content-center"
              v-if="user.institutional != null"
            >
            </b-row>
            <b-row class="justify-content-center" v-else>
              <b-button to="/reksadana" class="btn-secondary px-5 py-3">
                + Tambah Investasi
              </b-button>
            </b-row>
          </div>
        </b-skeleton-wrapper>
      </b-container>
    </div>
    <Footer3 />
  </div>
</template>

<script>
import Header from "@/components/partials/header/Header.vue";
import HeaderBottomPortfolio from "@/components/partials/header/HeaderBottomPortfolio.vue";
import Footer3 from "@/components/partials/footer/Footer3.vue";
import axios from "axios";
import { mapGetters } from "vuex";

const instance = axios.create({
  withCredentials: true,
});

export default {
  name: "Portfolio",
  metaInfo: {
    title: "Portfolio | Invesnow.id",
  },
  components: {
    Header,
    HeaderBottomPortfolio,
    Footer3,
  },
  data: () => ({
    // products: [],
    userPortfolios: [],
    portoDetail: [],
    portfolios: [],
    modalInvestasi: [],
    date_performa_nav: "",
    loading: false,
    loadingTime: 0,
    maxLoadingTime: 3,
    sumNominalInvest: null,
    modalInvestasiNominal: null,
    sumNominalInvest_usd: null,
    modalInvestasiNominal_usd: null,
    redeem_transaction: [],
    total_return_rupiah: null,
    total_return_percent: null,
    total_return_percent_usd: null,
    ShowActivitiesChecked: false,
    orders: "",
  }),

  computed: {
    ...mapGetters({
      access_token: "auth/access_token",
      bearer_token: "bearer_token",
      check: "auth/check",
      user: "auth/user",
      app_url: "app_url",
    }),
    subscriptionTrx: function () {
      return this.orders.filter(function (u) {
        return u.id_transaction_type == 1;
      });
    },
    redeemTrx: function () {
      return this.orders.filter(function (u) {
        return u.id_transaction_type == 2;
      });
    },
    switchingTrx: function () {
      return this.orders.filter(function (u) {
        return u.id_transaction_type == 3;
      });
    },
  },

  created() {
    this.fetchPortfolios();
    this.fetchOrders();
    this.$_loadingTimeInterval = null;
  },

  watch: {
    loading(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.clearLoadingTimeInterval();

        if (newValue) {
          this.$_loadingTimeInterval = setInterval(() => {
            this.loadingTime++;
          }, 1000);
        }
      }
    },
    loadingTime(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue === this.maxLoadingTime) {
          this.loading = false;
        }
      }
    },
  },
  methods: {
    clearLoadingTimeInterval() {
      clearInterval(this.$_loadingTimeInterval);
      this.$_loadingTimeInterval = null;
    },

    async fetchPortfolios() {
      this.loading = true;
      if (this.user.institutional == null) {
        let response = await instance({
          method: "GET",
          url: `${this.app_url}1722?type=Individual&id=${this.user.individual.id}`,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${this.access_token}`,
          },
        });
        this.userPortfolios = response.data.data.userPortfolio;
        this.portoDetail = response.data.data.porttoDetail;
      } else {
        let response = await instance({
          method: "GET",
          url: `${this.app_url}1722?type=Institutional&id=${this.user.institutional.id}`,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${this.access_token}`,
          },
        });
        this.userPortfolios = response.data.data.userPortfolio;
        this.portoDetail = response.data.data.porttoDetail;
      }

      this.userPortfolios.map((portfolio) => {
        if (portfolio.product.fund_ccy == "IDR") {
          let detail = this.portoDetail[portfolio.product_id];
          let modal = 0;
          // let investasi = 0;
          let return_rupiah = 0;
          let return_percent = 0;
          modal =
            parseFloat(this.portoDetail[portfolio.product_id].balance_unit) *
            parseFloat(detail.nav_perolehan);
          // investasi =
          //   parseFloat(this.portoDetail[portfolio.product_id].balance_unit) *
          //   parseFloat(detail.nav_per_unit);
          // modal = numeral(modal).format("0.00");
          // investasi = numeral(investasi).format("0.00");

          return_rupiah = portfolio.amount - modal;
          return_percent = (return_rupiah / modal) * 100;

          this.modalInvestasiNominal += parseFloat(modal);
          this.sumNominalInvest += parseFloat(portfolio.amount);
          // this.sumNominalInvest += parseFloat(portfolio.amount_idr);

          this.total_return_rupiah =
            this.sumNominalInvest - this.modalInvestasiNominal;
          this.total_return_percent =
            (this.total_return_rupiah / this.modalInvestasiNominal) * 100;

          this.portfolios.push({
            modalInvestasi: detail.modal,
            return_rupiah: return_rupiah,
            return_persen: return_percent,
            amount: portfolio.amount,
            fund_name: portfolio.product.fund_name,
            product_id: portfolio.product.id,
            fund_type: portfolio.product.fund_type,
            fund_ccy: portfolio.product.fund_ccy,
            fund_code: portfolio.product.fund_code,
            min_sell: portfolio.product.min_sell,
            image: portfolio.product.image,
            im_id: portfolio.product.im_id,
            outstanding_unit_balance:
              this.portoDetail[portfolio.product_id].balance_unit,
            nav_per_unit: detail.nav_per_unit,
            nav_date: detail.nav_date,
            // investasi: detail.investasi,
            // porto_sementara:
            //   this.portoDetail[portfolio.product_id].balance_unit *
            //   detail.nav_per_unit,
          });

          return portfolio;
        } else if (portfolio.product.fund_ccy == "USD") {
          let detail = this.portoDetail[portfolio.product_id];
          let modal = 0;
          // let investasi = 0;
          let return_usd = 0;
          let return_percent_usd = 0;
          modal =
            parseFloat(this.portoDetail[portfolio.product_id].balance_unit) *
            parseFloat(detail.nav_perolehan);
          // investasi =
          //   parseFloat(this.portoDetail[portfolio.product_id].balance_unit) *
          //   parseFloat(detail.nav_per_unit);
          // modal = numeral(modal).format("0.00");
          // investasi = numeral(investasi).format("0.00");

          return_usd = portfolio.amount - modal;
          return_percent_usd = (return_usd / modal) * 100;

          this.modalInvestasiNominal_usd += parseFloat(modal);
          this.sumNominalInvest_usd += parseFloat(portfolio.amount);

          this.total_return_usd =
            this.sumNominalInvest_usd - this.modalInvestasiNominal_usd;
          this.total_return_percent_usd =
            (this.total_return_usd / this.modalInvestasiNominal_usd) * 100;

          this.portfolios.push({
            modalInvestasi: detail.modal,
            return_usd: return_usd,
            return_persen: return_percent_usd,
            amount: portfolio.amount,
            fund_name: portfolio.product.fund_name,
            product_id: portfolio.product.id,
            fund_type: portfolio.product.fund_type,
            fund_ccy: portfolio.product.fund_ccy,
            fund_code: portfolio.product.fund_code,
            min_sell: portfolio.product.min_sell,
            image: portfolio.product.image,
            im_id: portfolio.product.im_id,
            outstanding_unit_balance:
              this.portoDetail[portfolio.product_id].balance_unit,
            nav_per_unit: detail.nav_per_unit,
            nav_date: detail.nav_date,
            // investasi: detail.investasi,
            // porto_sementara:
            //   this.portoDetail[portfolio.product_id].balance_unit *
            //   detail.nav_per_unit,
          });

          return portfolio;
        }
      });

      this.loadingTime = 0;
    },
    async fetchOrders() {
      if (this.user.institutional != null) {
        let response = await instance({
          method: "GET",
          url: `${this.app_url}order-get?ifua_number=${this.user.institutional.ifua}`,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${this.access_token}`,
          },
        });
        this.orders = response.data.data;
      } else {
        let response = await instance({
          method: "GET",
          url: `${this.app_url}order-get?ifua_number=${this.user.individual.ifua}`,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${this.access_token}`,
          },
        });
        this.orders = response.data.data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.portfolio {
  background: #f3f4f6;
}
.investment-portfolio {
  background: white;
}
.portfolio-container {
  padding-top: 120px;
  padding-bottom: 40px;
}

.portfolio-product {
  background: #f3f4f6;
}

.portfolio-product-container {
  padding-bottom: 120px;
}

h1 {
  font-style: normal;
  font-weight: bold;
  font-size: 36px;
  color: #111827;
}

p {
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  color: #4b5563;
}

.portfolio-product-card {
  box-shadow: 0px 1px 2px rgba(107, 114, 128, 0.06),
    0px 1px 3px rgba(107, 114, 128, 0.15);
  border-radius: 6px;
}

.portfolio-on-process-card {
  h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    color: #6b7280;
  }
  p {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    color: #4b5563;
  }
  span {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #4b5563;
  }
}

.portfolio-title {
  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    color: #111827;
  }
}

.total-investment {
  border-left: 7px solid $secondaryColor;
  border-radius: 6px;
  h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    color: #111827;
  }
  p {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #9ca3af;
  }

  h2 {
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    color: #111827;

    span {
      font-style: normal;
      font-weight: bold;
      font-size: 18px;
      color: #6b7280;
      vertical-align: text-top;
    }
  }
}

.initial-investment {
  border-left: 7px solid $primaryColor;
  border-radius: 6px;

  h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;

    color: #111827;
  }
  p {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;

    color: #9ca3af;
  }

  h2 {
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    color: #111827;

    span {
      font-style: normal;
      font-weight: bold;
      font-size: 18px;
      color: #6b7280;
      vertical-align: text-top;
    }
  }
}

.profit-loss {
  border-left: 7px solid $tertiaryColor;
  border-radius: 6px;
  h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;

    color: #111827;
  }
  p {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;

    color: #9ca3af;
  }

  h2 {
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    color: #111827;

    span {
      font-style: normal;
      font-weight: bold;
      font-size: 18px;
      color: #6b7280;
      vertical-align: text-top;
    }
  }
  .percentage {
    color: #111827;
    vertical-align: text-bottom;
  }
}

.fund-name {
  img {
    border-radius: 6px;
    width: 40px;
  }

  h4 {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;

    color: #5c0dab;
    text-align: left;
  }

  p {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    color: #6b7280;
  }
}

.investment-value {
  p {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    white-space: nowrap;
    color: #6b7280;
  }

  h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    white-space: nowrap;
    color: #111827;
  }
}

.profit {
  p {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    white-space: nowrap;
    color: #6b7280;
  }

  h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    white-space: nowrap;
    color: #111827;
  }
}

.switching-link {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;

    color: #33075f;
    text-align: center;

    a {
      text-decoration: none;
      color: #33075f;
    }
  }
}

.redeem-link {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;

    color: #33075f;
    text-align: center;

    a {
      text-decoration: none;
      color: #33075f;
    }
  }
}

.fund-name-modal {
  img {
    border-radius: 6px;
    width: 40px;
  }

  h4 {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;

    color: #111827;
    text-align: left;
  }

  p {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    color: #6b7280;
    text-align: left;
  }
}

.value-now-modal {
  .variant {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;

    color: #4b5563;
    text-align: left;
  }

  .value {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;

    color: #1f2937;
    text-align: right;
  }
}

.initial-investment-modal {
  .variant {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;

    color: #4b5563;
    text-align: left;
  }

  .value {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;

    color: #1f2937;
    text-align: right;
  }
}

.profit-modal {
  .variant {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;

    color: #4b5563;
    text-align: left;
  }

  .value {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;

    color: #1f2937;
    text-align: right;
  }
}

.buy-cost-modal {
  .variant {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;

    color: #4b5563;
    text-align: left;
  }

  .value {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;

    color: #1f2937;
    text-align: right;
  }
}

.unit-modal {
  .variant {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;

    color: #4b5563;
    text-align: left;
  }

  .value {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;

    color: #1f2937;
    text-align: right;
  }
}

.show-transaction-proccess {
  p {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    color: #1f2937;
  }
}

.disclaimer {
  .card {
    background: #ebf8ff;
    border: 1px solid #90cdf4;
    box-shadow: 0px 1px 2px rgba(107, 114, 128, 0.06),
      0px 1px 3px rgba(107, 114, 128, 0.1);
    border-radius: 6px;
  }
  p {
    font-family: $inter;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    color: #2c5282;
    margin: 0px;
  }
  .disclaimer-link {
    color: #2c5282 !important;
    text-decoration: underline;
  }
}

hr {
  margin: 0 !important;
}

.btn-modal-portfolio {
  font-family: $inter;
  background: transparent;
  padding: 0;
  border: none;
}

.btn-modal-portfolio:focus {
  box-shadow: none !important;
}

.btn-modal-portfolio:active {
  background: transparent !important;
  outline: none !important;
}

.top-up-link {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}

@media only screen and (max-width: 768px) {
  .btn-secondary {
    font-size: 14px;
  }
  .portfolio-title {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .switching-link {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .redeem-link {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .top-up-link {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
